import { logAppEvent, openAppLogDirectory, sanitizeAppLogValue } from './appLogger';

export function logRtcEvent(flow, event, details = {}) {
  return logAppEvent(`rtc:${String(flow || 'unknown')}`, event, details);
}

// Keep the old helper name for RTC callers while the actual file is now the app log.
export function openRtcLogDirectory() {
  return openAppLogDirectory();
}

export { sanitizeAppLogValue as sanitizeRtcLogDetails };
